import { useFeatureFlag, useLocalizeText } from '@mews/framework';
import { FeatureFlag, TextKey } from '@mews-commander/enums';
import { TagList } from '@mews-commander/ui';
import { compactArray } from '@mews/fp';
import { Container } from '@optimus-web/core';
import { RoutingRuleListTableRowData } from '../types';

interface ConditionsCellProps {
    conditions: RoutingRuleListTableRowData['conditions'];
}

export const ConditionsCell: React.FC<ConditionsCellProps> = ({ conditions }) => {
    const lt = useLocalizeText();
    const granularRoutingRulesConditionsExtensionEnabled = useFeatureFlag(
        FeatureFlag.granularRoutingRulesConditionsExtensionEnabled
    );

    const { companies, travelAgencies, rates, prepayment, guestProfiles, reservationGroupIds, reservationIds } =
        conditions;

    const companiesCount = companies.length + travelAgencies.length;
    const ratesCount = rates.flatMap((rate) => rate.rates ?? []).length;

    const ratesWithServices = ratesCount
        ? rates.map((rate) => {
              const rateCount = rate.rates.length;
              return rateCount
                  ? `${lt({
                        textKey: TextKey.RateCount,
                        substitutes: { count: rateCount },
                    })} - ${rate.serviceName}`
                  : null;
          })
        : [];

    return (
        <Container maxHeight={granularRoutingRulesConditionsExtensionEnabled ? '75px' : '160px'}>
            <TagList
                vertical
                compact
                tagsVariant="basicSubtle"
                tags={compactArray([
                    prepayment ? lt({ textKey: TextKey.RoutingRulesTableReservationConditionsPrepaidInOTA }) : null,
                    companiesCount
                        ? lt({ textKey: TextKey.CompanyCount, substitutes: { count: companiesCount } })
                        : null,
                    ...ratesWithServices,
                    granularRoutingRulesConditionsExtensionEnabled && guestProfiles.length
                        ? lt({
                              textKey: TextKey.GuestCount,
                              substitutes: { count: guestProfiles.length },
                          })
                        : null,
                    granularRoutingRulesConditionsExtensionEnabled && reservationGroupIds.length
                        ? lt({
                              textKey: TextKey.ReservationGroupCount,
                              substitutes: { count: reservationGroupIds.length },
                          })
                        : null,
                    granularRoutingRulesConditionsExtensionEnabled && reservationIds.length
                        ? lt({
                              textKey: TextKey.ReservationCount,
                              substitutes: { count: reservationIds.length },
                          })
                        : null,
                ])}
            />
        </Container>
    );
};
